import { z } from "zod";

const schema = z.object({
  startDate: z.date(),
  totalAmountCents: z
    .number()
    .int()
    .min(1, { message: "Salary is required" })
    .nullable()
    .refine((v) => v !== null, { message: "Salary is required" }),
  note: z.string().optional(),
});

type Schema = z.infer<typeof schema>;

export { schema as fullTimeOfferForm, type Schema as FullTimeOfferForm };
